'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  from: null,
  previewText: null,
  seen: null,
  senderType: null,
  subject: null,
  timestamp: null
}, 'LatestEmailMessage');
module.exports = exports['default'];